var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("m-add-references", {
        ref: "add",
        attrs: { "field-name": _vm.fieldName, list: _vm.values },
        on: { add: _vm.addVariants },
      }),
      _c("m-reference-list", {
        ref: "list",
        attrs: { "field-name": _vm.fieldName, list: _vm.list },
        on: {
          addVariant: _vm.addVariant,
          removeVariant: _vm.removeVariant,
          updated: _vm.submit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }